export function camelCaseToTitleCase(camelCase) {
    if (camelCase == null || camelCase == '') {
        return camelCase;
    }
    let output = camelCase.trim().replace(/([A-Z])/g, $1 => {
        return ' ' + $1;
    });
    return output[0].toUpperCase() + output.slice(1);
}



// WEBPACK FOOTER //
// ./src/components/helpers/camelCaseToTitleConverter.js